/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */
import { createMedia } from '@artsy/fresnel';
import { observer } from 'mobx-react-lite';
import React, { Component, useState } from 'react';
import {
  Icon,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from 'semantic-ui-react';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import PartnerStateContainer from '../UserInitializer/PartnerStateContainer';
import MobileSliderMenu from './MobileSliderMenu';
import NavigationMenu from './NavigationMenu';
import PartnerLogoComponent from '../../Pages/Admin/PartnerLogoComponent';
import styles from './Layout.style.module.css';

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

class DesktopContainer extends Component<{ title?: string }> {
  state: any = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;

    return (
      <>
        <Media greaterThan='mobile'>
          <Visibility
            once={false}
            onBottomPassed={this.showFixedMenu}
            onBottomPassedReverse={this.hideFixedMenu}
          >
            <div>
              <NavigationMenu />
              <div
                style={{
                  padding: 20,
                  maxWidth: 875,
                  margin: 'auto',
                }}
              >
                {children}
              </div>
            </div>
          </Visibility>
        </Media>
      </>
    );
  }
}

const MobileContainer: React.FC = (props) => {
  const [sidebarOpened, setSidebarOpened] = useState(false);
  const { partnerStore, caregiverStore } = useAgeReadyContext();

  const handleSidebarHide = () => setSidebarOpened(false);

  const handleToggle = () => setSidebarOpened(true);

  const { children } = props;

  const getPartnerCustomStyling = () => {
    if (partnerStore.partnersByIdMap.has(caregiverStore.partnerCode || '')) {
      return {
        backgroundColor: partnerStore.partnersByIdMap.get(
          caregiverStore.partnerCode || ''
        )?.navigationBarColor,
        fontColor: partnerStore.partnersByIdMap.get(
          caregiverStore.partnerCode || ''
        )?.fontColor,
        marginBottom: 0,
        flex: 1,
        flexBasis: '80%',
      };
    } else {
      return {
        backgroundColor: '#ffffff',
        marginBottom: 0,
      };
    }
  };

  return (
    <Media at='mobile' className={styles['mobile-fixed-height']}>
      <Sidebar.Pushable className={styles['mobile-fixed-height']}>
        <Sidebar
          direction={'right'}
          width={'thin'}
          as={Menu}
          inverted
          style={{ background: '#0000007a' }}
          animation='push'
          onHide={handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <MobileSliderMenu />
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened} className={styles['mobile-fixed-height']}>
          <Segment
            inverted
            textAlign='center'
            style={{
              backgroundColor: 'rgba(13, 40, 71,0)',
              padding: 0,
            }}
            vertical
          >
            <Menu
              inverted
              secondary
              size='large'
              style={getPartnerCustomStyling()}
              className={styles.logoLeftContainer}
            >
              <Menu.Item id={styles['mobile-header-logo-item']}>
                <PartnerLogoComponent />
              </Menu.Item>

              <Menu.Item style={{ paddingLeft: 0 }} onClick={handleToggle}>
                <Icon
                  size={'big'}
                  style={{
                    margin: 0,
                    color: '#343C4C',
                  }}
                  name='sidebar'
                />
              </Menu.Item>
            </Menu>
          </Segment>

          <div
            style={{
              padding: 20,
              maxWidth: 875,
              margin: 'auto',
              height: '100%',
            }}
          >
            {children}
          </div>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Media>
  );
};

const ResponsiveContainer: React.FC<{ children: any; title: string }> = ({
  children,
  title,
}) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <PartnerStateContainer>
    <BackgroundContainer title={title}>{children}</BackgroundContainer>
  </PartnerStateContainer>
);

export default ResponsiveContainer;

export const withResponsiveContainer = (Component: any, title: string) => {
  // eslint-disable-next-line react/display-name
  return (props: any) => (
    <ResponsiveContainer title={title}>
      <Component {...props} />
    </ResponsiveContainer>
  );
};

const BackgroundContainer: React.FunctionComponent<{
  children: any;
  title: string;
}> = observer(({ children, title }) => {
  const { partnerStore, caregiverStore } = useAgeReadyContext();

  const getPartnerCustomStyling = () => {
    if (partnerStore.partnersByIdMap.has(caregiverStore.partnerCode || '')) {
      return {
        backgroundColor: partnerStore.partnersByIdMap.get(
          caregiverStore.partnerCode || ''
        )?.backgroundColor,
        marginBottom: 0,
        minHeight: '100vh'
      };
    } else {
      return {
        backgroundColor: '#f5f5f5',
        marginBottom: 0,
        minHeight: '100vh'
      };
    }
  };

  return (
    <>
      <div style={getPartnerCustomStyling()}>
        <MediaContextProvider>
          <DesktopContainer title={title}>{children}</DesktopContainer>
          <MobileContainer>{children}</MobileContainer>
        </MediaContextProvider>
      </div>
    </>
  );
});
